module.exports = __webpack_public_path__ + "static/media/MP_Text.404c8897.svg";